module.exports = __webpack_public_path__ + "img/lock_view_lesson.1899b6c7.svg";